import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISnippetsService = ( createDecorator('snippetService'));
export { ISnippetsService };
